@if (isLoading()) {
    <generic-skeleton></generic-skeleton>
} @else {
    <pega-mobiel
        (assignmentNameChanged)="onAssignmentNameChanged($event)"
        (caseChange)="onCaseChange($event)"
        (caseTypeChange)="onCaseTypeChange($event)"
        (close)="onClose($event)"
        (loadAction)="onLoadAction($event)"
        (onAssignmentComplete)="onAssignmentComplete($event)"
        [actionID]="pegaResumeActionID"
        [assignmentID]="pegaResumeAssignmentID"
        [caseID]="pegaResumeCaseID"
        [caseTypeID]="caseTypeID()"
        [confirmBeforeExit]="confirmBeforeExit"
        [content]="pegaContent"
        [forceNativeBackButton]="forceNativeBackButton"
        [initWithSubmit]="pegaResumeInitWithSubmit"
        [pegaExtraHeaders]="pegaExtraHeaders"
        [title]="starterAppTitle"
        [useState]="apPegaUseState"
        data-bb="pega-mobiel"
    ></pega-mobiel>
}
